import React from 'react';

import styles from './Multiple.module.css';
import Question from '../../../interfaces/question';
import SubQuestion from './SubQuestion';
import breakpoints from '../../../utils/breakpoints';
import useCurrentWidth from '../../commons/use-current-width/useCurrentWidth';

export interface MultipleProps {
  questions: Question[];
}

const Multiple: React.FunctionComponent<MultipleProps> = ({ questions }) => {
  const [firstQuestion] = questions;
  const groupingLabels = firstQuestion.radioButtonOptions.map((r) => r.description);
  const groupingLabelsArePresent = groupingLabels.length !== 0;
  const currentWidth = useCurrentWidth();
  const isDesktop = currentWidth >= breakpoints.medium;
  const displayGroupingLabels = groupingLabelsArePresent && isDesktop;

  return (
    <div className={styles.multipleContainer}>
      {displayGroupingLabels && (
        <div className={styles.headerContainer}>
          <div className={styles.emptyLabel} />
          <div className={styles.groupingLabels}>
            {groupingLabels.map((description) => (
              <div className={styles.groupingLabel} key={description?.split(' ').join('-')}>
                <span>{description}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      {questions.map((q) => (
        <SubQuestion question={q} key={`subQuestion-${q.id}`} />
      ))}
    </div>
  );
};

Multiple.displayName = 'Multiple';

export default Multiple;
